var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBits = function SvgBits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.667V1L1.5 7.708 6 4.667Z",
    fill: "#7831F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.667V1l4.5 6.708L6 4.667Z",
    fill: "#AE83F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.664V11L1.5 7.708 6 4.664Z",
    fill: "#A78AF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.664V11l4.5-3.292L6 4.664Z",
    fill: "#CAB9FB"
  })));
};

export { SvgBits as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTIgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik02IDQuNjY3VjFMMS41IDcuNzA3NTlMNiA0LjY2N1oiIGZpbGw9IiM3ODMxRjAiLz4KPHBhdGggZD0iTTYgNC42NjdWMUwxMC41IDcuNzA3NTlMNiA0LjY2N1oiIGZpbGw9IiNBRTgzRjYiLz4KPHBhdGggZD0iTTYgNC42NjM2N1YxMUwxLjUgNy43MDc1OUw2IDQuNjYzNjdaIiBmaWxsPSIjQTc4QUY4Ii8+CjxwYXRoIGQ9Ik02IDQuNjYzNjdWMTFMMTAuNSA3LjcwNzU5TDYgNC42NjM2N1oiIGZpbGw9IiNDQUI5RkIiLz4KPC9zdmc+Cg==";